module.exports = __webpack_public_path__ + "img/downloadPdf.b5c72120.png";